import React from "react";
import { Link } from "react-router-dom";
import "./Header.css";


function Header() {
  return (
    <div className="header_wrap">
        <div className="header_inner ">
        <div className="container">
          <div className="left">
            <p>
              Open To New <span className="cambon_font"> Opportunities.</span>
            </p>
          </div>
          <div className="right">
            <p>
              <Link to="/">
                <span className="cambon_font">TechFreelanceX</span>
              </Link>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Header;
